import { useSiteSettings } from "@/lib/useSiteSettings";

const committee = [
  { name: "Juan Carlos Muñoz", role: "Presidente", icon: "ri-user-star-line" },
  { name: "María Elena Soto", role: "Secretaria", icon: "ri-user-line" },
  { name: "Pedro Fuentes", role: "Tesorero", icon: "ri-user-line" },
  { name: "Ana Rojas", role: "Directora", icon: "ri-user-line" },
  { name: "Luis Contreras", role: "Director", icon: "ri-user-line" },
];

export default function AboutPage() {
  const siteConfig = useSiteSettings();
  return (
    <main className="pt-24 pb-20 min-h-screen bg-white">
      {/* Hero */}
      <section className="relative h-64 md:h-80 overflow-hidden mb-16">
        <img
          src="https://readdy.ai/api/search-image?query=rural%20water%20infrastructure%20Chile%20community%20water%20system%20pipes%20pump%20station%20green%20landscape%20mountains&width=1400&height=500&seq=about1&orientation=landscape"
          alt="Sobre el APR"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-sky-900/60 flex items-center justify-center">
          <div className="text-center text-white px-4">
            <h1
              className="text-4xl md:text-5xl font-extrabold mb-3"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Sobre el APR
            </h1>
            <p className="text-sky-200 text-lg">Conoce nuestra historia, misión y equipo</p>
          </div>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Description + image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <span className="text-sky-500 text-sm font-semibold uppercase tracking-wider">Quiénes somos</span>
            <h2
              className="text-3xl md:text-4xl font-extrabold text-sky-900 mt-2 mb-6"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              {siteConfig.aprFullName}
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Somos una organización comunitaria sin fines de lucro que administra y opera el sistema de agua potable rural de nuestra localidad desde hace más de 20 años. Nuestro trabajo garantiza el acceso a agua potable de calidad para más de 450 familias de la comunidad.
            </p>
            <p className="text-slate-600 leading-relaxed mb-6">
              Contamos con un equipo de operadores técnicos capacitados y un directorio elegido democráticamente por los propios socios, quienes velan por la correcta administración de los recursos y la calidad del servicio.
            </p>
            <ul className="space-y-3">
              {[
                "Suministro continuo de agua potable de calidad",
                "Gestión transparente y participativa",
                "Inversión permanente en infraestructura",
                "Educación sobre uso eficiente del agua",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-slate-700 text-sm">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="w-full h-80 md:h-96 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=rural%20water%20committee%20team%20Chile%20community%20workers%20water%20system%20maintenance%20professional%20outdoor&width=700&height=500&seq=about2&orientation=landscape"
              alt="Equipo APR"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Mission */}
        <div className="bg-sky-50 rounded-2xl p-8 md:p-12 mb-16">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-sky-500 text-white mx-auto mb-6">
              <i className="ri-focus-3-line text-2xl"></i>
            </div>
            <h2
              className="text-2xl md:text-3xl font-extrabold text-sky-900 mb-4"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Nuestra Misión
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed">
              Garantizar el acceso permanente, seguro y de calidad al agua potable para todos los socios y sus familias, administrando eficientemente los recursos hídricos y la infraestructura del sistema, con transparencia, participación comunitaria y compromiso con el desarrollo sostenible de nuestra localidad.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {[
            { icon: "ri-home-4-line", value: "+450", label: "Familias conectadas" },
            { icon: "ri-map-pin-line", value: "12 km²", label: "Área de cobertura" },
            { icon: "ri-calendar-line", value: "+20", label: "Años de servicio" },
            { icon: "ri-drop-line", value: "24/7", label: "Monitoreo del sistema" },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-6 rounded-2xl border border-slate-100">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-sky-100 text-sky-600 mx-auto mb-3">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <div className="text-3xl font-extrabold text-sky-900 mb-1">{stat.value}</div>
              <div className="text-slate-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Committee */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <span className="text-sky-500 text-sm font-semibold uppercase tracking-wider">Directorio</span>
            <h2
              className="text-3xl font-extrabold text-sky-900 mt-2"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Comité Administrativo
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            {committee.map((member) => (
              <div key={member.name} className="flex flex-col items-center text-center p-5 rounded-2xl border border-slate-100 hover:border-sky-200 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-sky-100 text-sky-600 mb-3">
                  <i className={`${member.icon} text-2xl`}></i>
                </div>
                <h4 className="font-bold text-sky-900 text-sm leading-snug mb-1">{member.name}</h4>
                <span className="text-xs text-sky-500 font-medium">{member.role}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Coverage & Schedule */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 rounded-2xl bg-sky-50 border border-sky-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500 text-white">
                <i className="ri-map-pin-line text-xl"></i>
              </div>
              <h3 className="font-bold text-sky-900 text-lg">Área de cobertura</h3>
            </div>
            <p className="text-slate-600 text-sm leading-relaxed">
              Nuestro sistema abastece a los sectores: Calle Principal, Pasaje Los Aromos, Calle El Sauce, Sector El Manzano y comunidades aledañas, cubriendo un área aproximada de 12 km² en la localidad rural.
            </p>
          </div>
          <div className="p-6 rounded-2xl bg-emerald-50 border border-emerald-100">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-500 text-white">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="font-bold text-sky-900 text-lg">Horarios de atención</h3>
            </div>
            <div className="space-y-2 text-sm text-slate-600">
              <div className="flex justify-between">
                <span>Oficina presencial:</span>
                <span className="font-semibold">{siteConfig.schedule}</span>
              </div>
              <div className="flex justify-between">
                <span>Pago en línea:</span>
                <span className="font-semibold">24 horas / 7 días</span>
              </div>
              <div className="flex justify-between">
                <span>Emergencias:</span>
                <span className="font-semibold">{siteConfig.phone}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
